
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const userApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getUsers: build.query<any, void>({
      query: () => ({
        url: appEndpoint.getUsers,
        method: 'get',
      }),
      providesTags: ['User'],
    }),   
    
  deleteUser: build.mutation<void, string>({
        query: (id) => ({
          url: `${appEndpoint.deleteUser}/${id}`,
          method: 'delete',
        }),
        invalidatesTags: ['User'],
  }),
  
  addUser: build.mutation<any, CommandRequest>({
    query: (data) => ({
      url: appEndpoint.addUser,
      method: 'post',
      data: data.body
    }),
    invalidatesTags: (result) => (result ? ["User"] : []),
  }),

  updateUser: build.mutation<any, CommandRequest>({
    query: (data) => ({
      url: `${appEndpoint.updateUser}/${data.id}?_method=put`,
      method: 'post',
      data: data.body
    }),
    invalidatesTags: (result) => (result ? ["User"] : []),
  }),
  
  }),
  overrideExisting: false,
});

export const {
  useGetUsersQuery,
  useDeleteUserMutation,
  useAddUserMutation,
  useUpdateUserMutation
} = userApi;